import AreasOfLawInput from './AreasOfLawInput'

export default AreasOfLawInput
